import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { IDemandEditState, DemandEditState } from './states.store';
import getters from './getters.store';
import actions from './actions.store';
import mutations from './mutations.store';
import { DemandServices } from '../../../services';
import { DemandModel } from '../../../models/demand';

export class DemandEditModule<RootState> implements Module<IDemandEditState, RootState>{
	namespaced: boolean;
	state: IDemandEditState;
	getters: GetterTree<IDemandEditState, RootState>;
	actions: ActionTree<IDemandEditState, RootState>;
	mutations: MutationTree<IDemandEditState>;
	
	constructor() {
		this.namespaced = true;
		this.state = new DemandEditState({
			service: new DemandServices,
			demand: new DemandModel({
				InputEntries: [],
				DemandMults: [],
				RegionEntries: []
			}),
		})
		this.mutations = mutations;
		this.actions = actions;
		this.getters = getters;
	}
}